// Organizations the API has refused to serve during this browser session.
//
// A 401 on an organization-scoped endpoint switches organization and hard-reloads the app. Without
// a memory of what was refused, the reload picks the same organization again, gets the same 401 and
// reloads again -- the endless flicker the plus showcase page fell into once account deletion
// handed PBSupport organizations it had no membership row for.
const STORAGE_KEY = 'deniedOrganizationIds'

// Ids arrive as numbers from the API and as strings from storage, so everything is compared as a
// string. sessionStorage throws in some privacy modes, hence the guards.
const readDenied = () => {
    try {
        const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY))
        return Array.isArray(stored) ? stored.map(String) : []
    } catch {
        return []
    }
}

export const isOrganizationDenied = (organizationId) => {
    return organizationId !== null && organizationId !== undefined && readDenied().includes(String(organizationId))
}

export const denyOrganization = (organizationId) => {
    if (organizationId === null || organizationId === undefined || isOrganizationDenied(organizationId)) {
        return
    }
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...readDenied(), String(organizationId)]))
    } catch {
        // Nothing to remember it in; the caller's "did the organization change" guard still stops
        // the reload loop, it just cannot skip the refused organization on the next visit.
    }
}

export const clearDeniedOrganizations = () => {
    try {
        sessionStorage.removeItem(STORAGE_KEY)
    } catch {
        // ignore
    }
}
